// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1469":"a2b77e7e102659db","1948":"997dbe1315dfe2d5"}[chunkId] + ".js";
};